import { create } from 'zustand';
import { isNotNullOrUndefined, isNullOrUndefined } from '@utils/utils.tsx';
import { catalogApi } from '@api/api-config.ts';
import { useFavouritesStore } from '@features/favouries/useFavouritesStore.ts';
import { useOrgPortal } from '@hooks/useOrgPortal.ts';
import { CatalogReponse } from '@api/generated/pecosta-search-service';

interface CatalogView {
  categoryEcid: string | null;
  supplierIds: number[] | undefined;
  supplierFilterLevel: number | undefined;
  isInitialized: boolean;
  catalogResponse: CatalogReponse | undefined;

  initializeCatalog: (categoryEcid: string | null, supplierIds: number[] | undefined, supplierFilterLevel: number | undefined) => void;
  navigateToCategoryEcid: (categoryEcid: string) => void;
  handleSupplierIdsChange: (supplierIds: number[]) => void;
}

export const useCreateCatalogViewStore = create<CatalogView>((set, get) => ({
  categoryEcid: '',
  supplierIds: undefined,
  supplierFilterLevel: undefined,
  isInitialized: false,
  catalogResponse: undefined,

  initializeCatalog: async (categoryEcid, supplierIds, supplierFilterLevel) => {
    console.log('initializeCatalog', { categoryEcid, supplierIds, supplierFilterLevel });
    // při přechodu na jinou kategorii vyčistit starý obsah, aby neproblikl, než dorazí nová data
    if (get().categoryEcid !== categoryEcid) {
      set({ catalogResponse: undefined });
    }
    const { orgId, portalId } = useOrgPortal.getState();
    try {
      const response = await catalogApi.getCatalog({
        portalId: portalId,
        buyerId: orgId,
        categoryEcid: categoryEcid ? categoryEcid : '',
        firstNProducts: 16, // FIXME: rozhodneme se, zda budeme resit...
        supplierIds: supplierIds ?? [],
      });
      useFavouritesStore.getState().loadFavourites();
      set({ categoryEcid, supplierIds, supplierFilterLevel, isInitialized: true, catalogResponse: response.data });
    } catch (error) {
      set({ categoryEcid, supplierIds, supplierFilterLevel });
    }
  },
  navigateToCategoryEcid: (categoryEcid: string) => {
    const { supplierFilterLevel, supplierIds } = get();
    console.log('navigateToCategoryEcid', { categoryEcid, supplierFilterLevel, supplierIds });
    const newCategoryLevel = categoryEcid === '' || isNullOrUndefined(categoryEcid) ? 0 : categoryEcid.split('-').length;

    if (isNotNullOrUndefined(supplierFilterLevel) && newCategoryLevel < supplierFilterLevel) {
      // jdeme nahoru
      console.log('navigateToCategoryEcid: up', { categoryEcid, supplierFilterLevel, supplierIds });
      set({ isInitialized: true, categoryEcid, supplierIds: [], supplierFilterLevel: undefined });
    } else {
      console.log('navigateToCategoryEcid: down', { categoryEcid, supplierFilterLevel, supplierIds });
      set({ isInitialized: true, categoryEcid, supplierIds, supplierFilterLevel });
    }
  },
  handleSupplierIdsChange: (newSupplierIds: number[]) => {
    const { categoryEcid, supplierIds } = get();

    console.log('handleSupplierIdsChange', { newSupplierIds, categoryEcid, supplierIds });
    if (newSupplierIds.length === 0 && supplierIds?.length === 0) {
      return;
    }

    // ukoncujeme
    if (newSupplierIds.length === 0) {
      console.log('handleSupplierIdsChange - koncujeme', newSupplierIds);
      set({ isInitialized: true, supplierIds: [], supplierFilterLevel: undefined });
      return;
    }

    if (supplierIds && supplierIds.length > 0) {
      // nebudeme menit level
      set({ isInitialized: true, supplierIds: newSupplierIds });
    } else {
      const newCategoryLevel = categoryEcid === '' || isNullOrUndefined(categoryEcid) ? 0 : categoryEcid.split('-').length;
      console.log('handleSupplierIdsChange: newCategoryLevel', { newSupplierIds, categoryEcid, supplierIds });
      set({ isInitialized: true, supplierIds: newSupplierIds, supplierFilterLevel: newCategoryLevel });
    }
  },
}));
